import Init from './Init';

export default async function setDados(url, js) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(js),
  };
  return new Promise(async function (resolve, reject) {
    fetch(url, requestOptions)
      .then((response) => {
        resolve(response.json());
      })
      .catch((erro) => reject({ auth: 0, erros: erro }));
  });
}

async function writeDados(url, js) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(js),
  };
  return new Promise(async function (resolve, reject) {
    fetch(url, requestOptions)
      .then((response) => {
        resolve(response.json());
      })
      .catch((erro) => reject({ auth: 0, erros: erro }));
  });
}

async function getDados(url, js) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(js),
  };

  return new Promise(async function (resolve, reject) {
    fetch(url, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((jsonData) => {
        try {
          if (jsonData.auth === 0 && jsonData.info.erro === 'Autenticação Inválida') {
            localStorage.clear();
            window.location.reload();
          }
        } catch (erro) {
          console.log('err:' + erro);
        }
        resolve(jsonData);
      })
      .catch((erro) => {
        console.log(erro);
        reject({ auth: 0, erros: erro });
      });
  });
}

async function getFile(url, js) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(js),
  };
  return new Promise(async function (resolve, reject) {
    fetch(url, requestOptions)
      .then((response) => {
        response
          .blob()
          .then((r) => {
            var url = window.URL.createObjectURL(r);
            var a = document.createElement('a');

            a.href = url;
            a.download = 'HistoricoCognos.xlsx';
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            //a.click();

            resolve(r);
          })
          .catch((erro) => reject({ auth: 0, erros: 'Erro blob:' + erro }));
      })
      .catch((erro) => reject({ auth: 0, erros: erro }));
  });
}

function getAmbientes(body) {
  return new Promise(function (resolve, reject) {
    getDados(`${Init.url}getAmbientes`, body)
      .then((js) => {
        resolve(js);
      })
      .catch(() => {
        resolve([]);
      });
  });
}
async function getDocument() {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  return new Promise(async function (resolve, reject) {
    fetch('http://10.56.17.12:3001/back/getDocument')
      .then((response) => {
        return response.json();
      })
      .then((jsonData) => {
        resolve(jsonData);
      })
      .catch((erro) => {
        console.log(erro);
        reject({ auth: 0, erros: erro });
      });
  });
}

export { writeDados, getDados, getFile, getAmbientes, getDocument };
